import { AppError } from '../models/error.model';
import { ErrorType } from '../operators/error.operator';

type ErrorDispatchFn = (error: AppError, level: ErrorType) => void;

let _dispatch: ErrorDispatchFn | undefined;

export function registerErrorDispatcher(fn: ErrorDispatchFn): void {
  _dispatch = fn;
}

export function dispatchAppError(error: AppError, level: ErrorType): void {
  _dispatch?.(error, level);
}
